import React from 'react'
import { WwaCheckbox } from "../../common/components/WwaInputElements";
import { winterTypeIcons } from "common/helpers/helpers";
import 'common/css/inputElements.css'

const getWinterIcon = (winterType, on) =>
  winterType ? (
    <img
      src={winterTypeIcons[winterType][true]}
      alt={winterType}
      style={{ width: "20px", height: "20px", opacity: "0.8", marginRight: "0.3em" }}
    />
  ) : null;

const SiteReportCheckbox = ({u, siteId,
    handleReportCheckboxChange, handleReportSubtypeChange,
    reportSubs, isFetching, reportType, winterType}) => (
  <React.Fragment>
    {getWinterIcon(winterType, true)}
    <WwaCheckbox id={`site-report-user-${u.id}`}
                 name={reportSubs ? reportSubs.id : ''}
                 onChange={(e) => handleReportCheckboxChange(e, u, siteId, reportType)}
                 checked={!!reportSubs}
                 disabled={isFetching}
    />
    {reportType !== "snowtify"
      ?
        <select
          disabled={!reportSubs ? true : false}
          onChange={(e) => handleReportSubtypeChange(e,u,reportSubs)}
          className='wwa__select'
          value={reportSubs ? reportSubs.sendIfNecessary : true}
        >
          <option
            className='SiteSel__option'
            key={1}
            value={false}
          >Always</option>
          <option
            className='SiteSel__option'
            key={2}
            value={true}
          >Events Only</option>
        </select>
      : null
    }
  </React.Fragment>
)

export default SiteReportCheckbox
